$.fn.extend({
    loadOnScroll: function (params) {
        var items = $(this);
        items.each(function (i, container) {
            var container = $(container);
            var loadingInitScroll;
            var loading = false;
            var more = true;

            var updateContainerLoadingScroll = function () {
                loadingInitScroll = container.height() + container.offset().top - 2 * $(window).height();
            }

            var data = [];

            $(container).find(params.items).each(function (i, item) {
                data.push($(item).data('id'));
            })

            updateContainerLoadingScroll();

            $(window).on('media.pageStateInit', function () {
                updateContainerLoadingScroll();
            })

            $(window).on('media.pageStateChange', function () {
                updateContainerLoadingScroll();
            })

            $(window).scroll(function () {
                if (loading || ! more) {
                    return;
                }

                var scroll = $(window).scrollTop();
                if (scroll > loadingInitScroll) {
                    loading = true;
                    var param = $('meta[name=csrf-param]').attr("content");
                    var token = $('meta[name=csrf-token]').attr("content");
                    var url = $('meta[name=load-on-scroll-url]').attr("content") || '';
                    $.ajax({
                        url: url,
                        type: "POST",
                        data: {id: data, [param]: token}, 
                        dataType: 'json',
                        success: function (result) {

                            if (result.items) {
                                container.find(params.items + ":last").after($(result.items));
                                AOS.init();
                                data = [];
                                container.find(params.items).each(function (i, item) {
                                    data.push($(item).data('id'));
                                })
                                // onYouTubeIframeAPIReady();
                                updateContainerLoadingScroll();
                                loading = false;
                                $(window).trigger('scroll');
                            }
                            if (! result.more) {
                                more = false;
                            }
                        }
                    })
                }
            })
        })
    }
});
